// src/pages/Admin/AdminDashboard.jsx
import React, { useState, useEffect } from "react";
import { FaUsers, FaMoneyBillWave, FaArrowUp, FaArrowDown, FaInfoCircle, FaBars } from "react-icons/fa";

const AdminDashboard = () => {
  // ---------------- STATES ----------------
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("adminDarkMode");
    return saved ? JSON.parse(saved) : true;
  });

// Pending Funds state
const [funds, setFunds] = useState([]);

// 🔹 SUMMARY STATE (Total Users, Deposit, Withdraw etc.)
const [summary, setSummary] = useState({
  totalUsers: 0,
  pendingDeposits: 0,
  pendingWithdraws: 0,
  totalDeposit: 0,
  totalWithdraw: 0,
});

// 🔹 FETCH SUMMARY
useEffect(() => {
  const fetchSummary = async () => {
    try {
      const res = await fetch("https://api.earnmoney0.top/admin/summary");
      const data = await res.json();
      if (data.success) {
        setSummary(data.summary);
      }
    } catch (err) {
      console.error("Error fetching summary:", err);
    }
  };
  fetchSummary();
}, []);

// Fetch pending funds
useEffect(() => {
  const fetchFunds = async () => {
    try {
      const res = await fetch("https://api.earnmoney0.top/admin/pending-funds");
      const data = await res.json();
      if (data.success) setFunds(data.funds || []);
    } catch (err) {
      console.error("Fetch pending funds error:", err);
    }
  };
  fetchFunds();
}, []);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [exitDropdown, setExitDropdown] = useState(false);

  // Close sidebar / dropdown on outside click
  useEffect(() => {
  const handleClickOutside = (e) => {
    const sidebar = document.getElementById("sidebar");
    const menuBtn = document.getElementById("menu-btn");

    const exitBtn = document.getElementById("exit-btn");
    const exitDropdownEl = document.getElementById("exit-dropdown");

    // Sidebar close
    if (
      sidebarOpen &&
      sidebar &&
      !sidebar.contains(e.target) &&
      menuBtn &&
      !menuBtn.contains(e.target)
    ) {
      setSidebarOpen(false);
    }

    // Exit dropdown close
    if (
      exitDropdown &&
      exitBtn &&
      exitDropdownEl &&
      !exitBtn.contains(e.target) &&
      !exitDropdownEl.contains(e.target)
    ) {
      setExitDropdown(false);
    }
  };

  document.addEventListener("click", handleClickOutside);
  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, [sidebarOpen, exitDropdown]);

  // Toggle Dark Mode
  const toggleDarkMode = () => {
    setDarkMode(prev => {
      localStorage.setItem("adminDarkMode", JSON.stringify(!prev));
      return !prev;
    });
  };

  // ---------------- DATA ----------------
  const cards = [
  {
    title: "Total Users",
    icon: <FaUsers size={34} />,
    color: "#16a34a",
    value: summary.totalUsers,    // ✅ dynamic
    link: "/admin/users",
  },
  {
    title: "Deposit",
    icon: <FaArrowUp />,
    color: "#3b82f6",
    value: summary.pendingDeposits,  // ✅ dynamic
    link: "/admin/deposit",
  },
  {
    title: "Withdraw",
    icon: <FaArrowDown />,
    color: "#f97316",
    value: summary.pendingWithdraws, // ✅ dynamic
    link: "/admin/withdraw",
  },
  {
    title: "Total Deposit",
    icon: <FaArrowUp />,
    color: "#22c55e",
    value: summary.totalDeposit,    // ✅ dynamic
    link: "/admin/total-deposit",
  },
  {
    title: "User Info",
    icon: <FaInfoCircle />,
    color: "#eab308",
    value: summary.totalUsers,      // ✅ dynamic
    link: "/admin/user-info",
  },
  {
    title: "Total Withdraw",
    icon: <FaArrowDown />,
    color: "#f43f5e",
    value: summary.totalWithdraw,   // ✅ dynamic
    link: "/admin/total-withdraw",
  },
];

  return (
    <div
      style={{
        ...styles.page,
        background: darkMode ? "#0f172a" : "#f8fafc",
        color: darkMode ? "#fff" : "#0f172a",
      }}
    >
      {/* HEADER */}
      <div style={styles.header}>
        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
          <FaBars
            id="menu-btn"
            size={25}
            style={{ cursor: "pointer" }}
            onClick={() => setSidebarOpen(true)}
          />
          <h2>Admin Dashboard</h2>
        </div>

        <div id="exit-btn" style={{ position: "relative" }}>
  <button
    onClick={(e) => {
      e.stopPropagation(); // ❌ Prevent parent click from closing dropdown
      setExitDropdown(prev => !prev);
    }}
    style={styles.exitBtn}
  >
    Exit
  </button>

  {exitDropdown && (
  <div
    id="exit-dropdown"
    style={styles.dropdown}
    onClick={(e) => e.stopPropagation()}
  >
    <button
  style={styles.dropdownBtn}
  onClick={() => {
    localStorage.removeItem("adminToken"); // যদি থাকে
    window.location.href = "/admin/login";
  }}
>
  Log Out
</button>

    <div style={styles.darkModeToggle}>
      <span>Dark Mode</span>
      <label style={styles.switch}>
        <input
          type="checkbox"
          checked={darkMode}
          onChange={toggleDarkMode}
        />
        <span style={styles.slider}></span>
      </label>
    </div>
  </div>
)}
</div>
</div>

      {/* CARDS */}
      <div style={styles.cardsContainer}>
        {cards.map((c, i) => (
          <div
  key={i}
  onClick={() => c.link && (window.location.href = c.link)}
  style={{
    ...styles.card,
    cursor: c.link ? "pointer" : "default",
    background: darkMode ? "#1e293b" : "#fff",
    borderLeft: `5px solid ${c.color}`,
  }}
>
            <div style={{ fontSize: 28, color: c.color }}>{c.icon}</div>
            <h3
  style={{
    marginTop: 10,
    color: darkMode ? "#ffffff" : "#0f172a",
  }}
>
  {c.title}
</h3>

<p
  style={{
    marginTop: 5,
    fontSize: 18,
    fontWeight: 600,
    color: darkMode ? "#e5e7eb" : "#111827",
  }}
>
  {c.value}
</p>
          </div>
        ))}
      </div>

      {/* SIDEBAR */}
      <div
        id="sidebar"
        style={{
          ...styles.sidebar,
          transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
        }}
      >
        <h3 style={{ marginBottom: 20 }}>Menu</h3>
       <div style={styles.sidebarMenu}>

  <div
  style={styles.sidebarItem}
  onClick={() => window.location.href = "/admin/package"} // ➡️ Package পেজ লিঙ্ক
>
  <span style={styles.sidebarIcon}>📦</span>
  <span>Package</span>
</div>

 <div
  style={styles.sidebarItem}
  onClick={() => (window.location.href = "/admin/today-work")}
>
  <span style={styles.sidebarIcon}>🗓️</span>
  <span>Today Work</span>
</div>

  <div
  style={styles.sidebarItem}
  onClick={() => (window.location.href = "/admin/Payment-Setup")}
>
  <span style={styles.sidebarIcon}>💳</span>
  <span>Payment Setup</span>
</div>

  <div
  style={styles.sidebarItem}
  onClick={() => (window.location.href = "/admin/Deposit-Cancelled")}
>
  <span style={styles.sidebarIcon}>❌</span>
  <span>Deposit Cancelled</span>
</div>

  <div
   style={styles.sidebarItem}
   onClick={() => (window.location.href = "/admin/Withdraw-Cancelled")}
   >
    <span style={styles.sidebarIcon}>🚫</span>
    <span>Withdraw Cancelled</span>
  </div>

  <div
   style={styles.sidebarItem}
   onClick={() => (window.location.href = "/admin/account-setup")}
   >
    <span style={styles.sidebarIcon}>⚙️</span>
    <span>Account Setup</span>
  </div>

<div
   style={styles.sidebarItem}
   onClick={() => (window.location.href = "/admin/password-reset")}
>
    <span style={styles.sidebarIcon}>🔑</span>
    <span>Password Reset</span>
</div>

</div>
      </div>

      {/* OVERL{(sideAY */}
      {sidebarOpen && (
  <div
    style={styles.overlay}
    onClick={() => {
      setSidebarOpen(false);
    }}
  />
)}
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    padding: 20,
    fontFamily: "sans-serif",
    transition: "all 0.3s",
    position: "relative",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 30,
  },
  exitBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 600,
  },
  dropdown: {
    position: "absolute",
    top: 45,
    right: 0,
    background: "#1e293b",
    padding: 10,
    borderRadius: 8,
    minWidth: 150,
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    zIndex: 1000,
  },
  dropdownBtn: {
    background: "red",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 600,
  },
  darkModeToggle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  switch: {
    position: "relative",
    display: "inline-block",
    width: 40,
    height: 20,
  },
  slider: {
    position: "absolute",
    cursor: "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#ccc",
    borderRadius: 20,
    transition: ".4s",
  },
  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 20,
  },
  card: {
    borderRadius: 12,
    padding: 20,
    transition: "all 0.3s",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
  },
  sidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    width: 250,
    height: "100%",
    background: "#111827",
    color: "#fff",
    padding: 20,
    transition: "transform 0.3s ease",
    zIndex: 2000,
  },
  sidebarList: {
    listStyle: "none",
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: 15,
  },

sidebarMenu: {
  display: "flex",
  flexDirection: "column",
  gap: 14,
  marginTop: 20,
},

sidebarItem: {
  display: "flex",
  alignItems: "center",
  gap: 14,
  padding: "14px 16px",
  borderRadius: 12,
  background: "#020617",
  color: "#e5e7eb",
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
  transition: "0.25s",
},

sidebarIcon: {
  fontSize: 22,
},
  
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    zIndex: 1500,
  },
};

export default AdminDashboard;